export const REVIEW_DETAILS_PAGE_SIZE = 50;

export const REVIEW_DETAILS_CONTENT_MAX_WIDTH = 600;

export const REVIEW_DETAILS_INBOX_QUERY_LIMIT = 500;

export const REVIEW_SEEN_DWELL_MS = 1750;

export const REVIEW_SEEN_FLUSH_INTERVAL_MS = 2000;

export const REVIEW_SEEN_FLUSH_BATCH_SIZE = 10;

/** @typedef {'new-reviews' | 'all-reviews'} ReviewDetailsTab */

/** @typedef {'beer' | 'brewery'} ReviewDetailsItemType */
